import { createContext, useContext, useEffect, useState } from 'react';
import type { Partner } from '../client/portal/types.gen';
import { getPartnersService } from '../services/portalServices';

type SettingsContextProps = {
  partners: Partner[] | null;
};

type SettingsProviderProps = {
  children: JSX.Element | JSX.Element[];
};

const SettingsContext = createContext<SettingsContextProps | null>(null);

const SettingsProvider = ({ children }: SettingsProviderProps) => {
  const [partners, setPartners] = useState<Partner[] | null>([]);

  useEffect(() => {
    const getPartners = async () => setPartners(await getPartnersService());

    getPartners();
  }, []);

  return (
    <SettingsContext.Provider value={{ partners }}>
      {children}
    </SettingsContext.Provider>
  );
};

const useSettings = () => useContext(SettingsContext) as SettingsContextProps;

export { SettingsProvider, useSettings };
